export const WINERY_LOCATION = { lat: 50.84467696584722, lng: 19.10529871395841}